module.exports = __webpack_public_path__ + "static/img/xxqg.74235075.jpg";